export enum FormType {
    PostInspectionSurvey = 'PostInspectionSurvey',
    ClosedSurvey = 'ClosedSurvey',
    UtilitiesForm = 'UtilitiesForm',
}
